/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, email: NonNullable<unknown> }} Contact_Success_DescriptionInputs */

const en_contact_success_description = /** @type {(inputs: Contact_Success_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thanks ${i?.name}. We have your request and will reply to ${i?.email} within one business day.`)
};

/**
* | output |
* | --- |
* | "Thanks {name}. We have your request and will reply to {email} within one business day." |
*
* @param {Contact_Success_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_description = /** @type {((inputs: Contact_Success_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_success_description(inputs)
});